import React from 'react';
import * as RRD from 'react-router-dom';

type LinkProps = RRD.LinkProps & React.RefAttributes<HTMLAnchorElement>

export const Link: React.FC<LinkProps> = ({ ...props }) => (
    <RRD.Link
        viewTransition
        {...props}
    />
);
